<template>
  <div class="enjoy-combo">
    <div class="tuolele-main-box">
      <div class="data-form-title">设置套餐的具体内容</div>
      <el-form :model="comboObj" label-position="right" label-width="170px">
        <div class="combo-notice">
          <p>畅享套餐相关说明：</p>
          <p>
            1、若设置支持插班，套餐预览时，系统将自动生成两个套餐，确认无误后提交即可。
          </p>
          <p>2、若设置支持插班，只需设置一个套餐名称，系统将自带【插班】标识</p>
          <p>3、畅享套餐签约后，不予办理内转和退费。</p>
          <p>
            4、畅享套餐有效期到期后，套餐内课时将自动清零并关闭（停课期间课时正常消耗，不予延长课时）
          </p>
        </div>
        <el-form-item label="套餐类型" required>
          <el-select
            v-model="comboObj.item_type"
            placeholder="请选择"
            :disabled="isCreate"
          >
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐扣费方式">
          <span>月扣</span>
        </el-form-item>
        <el-form-item label="是否允许插班" required>
          <el-select
            v-model="placement"
            placeholder="请选择"
            :disabled="isCreate"
          >
            <el-option label="允许插班" value="1"></el-option>
            <el-option label="不允许插班" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐有效时间" required>
          <el-date-picker
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            v-model="comboObj.begin_time"
            :disabled="isCreate"
          ></el-date-picker>
          <i>至</i>
          <el-date-picker
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            v-model="comboObj.end_time"
            :disabled="isCreate"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="套餐售价（原价）" required>
          <el-input
            size="large"
            v-model="comboObj.total_free_price"
            placeholder="请输入"
            :disabled="isCreate"
          ></el-input>
          <i>元</i>
        </el-form-item>
        <el-form-item label="套餐实际销售价" required>
          <el-input
            size="large"
            v-model="comboObj.total_price"
            placeholder="请输入"
            :disabled="isCreate"
          ></el-input>
          <i>元</i>
        </el-form-item>
        <el-form-item label="材料费" >
          <el-input
            size="large"
            v-model="comboObj.extra_price"
            placeholder="请输入材料费"
            :disabled="isCreate"
          ></el-input>
          <i>元</i>
        </el-form-item>
        <el-form-item v-if="!isCreate">
          <el-button type="primary" @click="saveCombo">生成套餐</el-button>
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              <p class="el-tooltip__popper-text">
                操作提示：
                <br />1、请点击“生成套餐”按钮，系统将为您自动显示套餐详情
                <br />2、点击“修改套餐”按钮，可以继续编辑套餐详情
                <br />3、确认无误后，即可点击“提交套餐”按钮，系统将根据套餐预览详情，正式生成套餐！
              </p>
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </div>
    <div class="tuolele-main-box" v-if="isCreate">
      <div class="data-form-title">套餐详情预览</div>
      <div class="self-table">
        <div class="table-name">套餐名称 {{ comboObj.item_title }}</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>套餐类型</td>
                <td>扣费方式</td>
                <td>套餐有效期</td>
                <td>套餐课时</td>
                <td>套餐（原价）</td>
                <td>套餐实际销售价</td>
                <td>日均课耗</td>
                <td>日均退费</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ comboObj.item_type == 10 ? "常规畅享" : "假期畅享" }}
                </td>
                <td>月扣</td>
                <td>{{ comboObj.begin_time }}~{{ comboObj.end_time }}</td>
                <td v-if="comboObj.item_type == 10">
                  {{ comboObj.formal_day }}天
                </td>
                <td v-else>{{ comboObj.holiday_day }}</td>
                <td>{{ comboObj.total_free_price }}</td>
                <td>{{ comboObj.total_price }}</td>
                <td v-if="comboObj.item_type == 10">
                  {{ comboObj.item_price }}
                </td>
                <td v-else>{{ comboObj.holiday_price }}</td>
                <td>不支持内转或退费</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-price flex-wrap">
          <div class="main-font-color">
            套餐售价（原价）：{{ comboObj.total_free_price }}
          </div>
          <div class="color-danger">
            套餐实际销售价：{{ comboObj.total_price }}
          </div>
        </div>
      </div>
      <div class="self-table" v-if="placement == 1">
        <div class="table-name">
          套餐名称 【插班】 {{ comboObj.item_title }}
        </div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>套餐类型</td>
                <td>扣费方式</td>
                <td>套餐有效期</td>
                <td>套餐课时</td>
                <td>套餐（原价）</td>
                <td>套餐实际销售价</td>
                <td>日均课耗</td>
                <td>日均退费</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ comboObj.item_type == 10 ? "常规畅享" : "假期畅享" }}
                </td>
                <td>月扣</td>
                <td>{{ comboObj.begin_time }}~{{ comboObj.end_time }}</td>
                <td v-if="comboObj.item_type == 10">
                  {{ comboObj.formal_day }}天
                </td>
                <td v-else>{{ comboObj.holiday_day }}</td>
                <td>{{ comboObj.total_free_price }}</td>
                <td>{{ comboObj.total_price }}</td>
                <td v-if="comboObj.item_type == 10">
                  {{ comboObj.free_item_price }}
                </td>
                <td v-else>{{ comboObj.free_holiday_price }}</td>
                <td>不支持内转或退费</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-price flex-wrap">
          <div class="main-font-color">插班天数（按天计算）：1天</div>
          <div v-if="comboObj.item_type == 10" class="color-danger">
            套餐实际销售价（按天计算）：{{ comboObj.free_item_price }}
          </div>
          <div v-else class="color-danger">
            套餐实际销售价（按天计算）：{{ comboObj.free_holiday_price }}
          </div>
        </div>
      </div>
      <div class="xxs_preview" v-if="comboObj.extra_price">
            <h4 style="color:#666666;margin-top:10px;margin-bottom:10px">材料费:  {{comboObj.extra_price}}元</h4>            
      </div>
      <el-button type="info" @click="isCreate = false">修改套餐</el-button>
      <el-button type="primary" @click="postCombo">提交套餐</el-button>
    </div>
  </div>
</template>

<script>
import Tool from '@/assets/js/tool.js'

export default {
  name: "enjoyCombo",
  props: {
    type: [String, Number],
    item_title: String,
    limited_number: [String, Number],
    grade_id: String,
    is_supplementary_agreement: [String, Number],
  },
  data() {
    return {
      typeList: [
        { text: "常规畅享", value: "10" },
        { text: "假期畅享", value: "11" }
      ],
      placement: "2",
      comboObj: {
        type: "",
        item_title: "",
        limited_number: "",
        grade_id: "",
        item_type: "",
        total_price: "",
        total_free_price: "",
        item_price: "",
        holiday_price: "",
        formal_day: "",
        holiday_day: "",
        begin_time: "",
        end_time: "",
        original_price: "",
        is_supplementary_agreement: "",
        extra_price: ""
      },
      isCreate: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    saveCombo() {
      // alert('bbbbb');
      // console.log(comboObj);
      if (this.item_title == "") {
        this.$message({
          message: "套餐名称不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.grade_id == "") {
        this.$message({
          message: "请选择适用年级",
          type: "warning"
        });
        return false;
      }
      this.comboObj.type = this.type;
      this.comboObj.item_title = this.item_title;
      this.comboObj.limited_number = this.limited_number;
      this.comboObj.grade_id = this.grade_id;
      this.comboObj.holiday_day = "";
      this.comboObj.formal_day = "";
      this.comboObj.item_price = "";
      this.comboObj.holiday_price = "";
      this.comboObj.free_holiday_price = "";
      this.comboObj.free_item_price = "";
      this.comboObj.original_price = this.comboObj.total_free_price;
      this.comboObj.is_supplementary_agreement = this.is_supplementary_agreement;
      if (this.comboObj.item_type == 10) {
        this.comboObj.formal_day = this.getComboDay(
          this.comboObj.begin_time,
          this.comboObj.end_time
        );
        this.comboObj.item_price = Tool.calcuateMoney(
          this.comboObj.total_price / this.comboObj.formal_day
        );
        if (this.placement == 1) {
          this.comboObj.free_item_price = Tool.calcuateMoney(
            this.comboObj.total_price / this.comboObj.formal_day
          );
        }
      } else {
        this.comboObj.holiday_day = this.getComboDay(
          this.comboObj.begin_time,
          this.comboObj.end_time
        );
        this.comboObj.holiday_price = Tool.calcuateMoney(
          this.comboObj.total_price / this.comboObj.holiday_day
        );
        if (this.placement == 1) {
          this.comboObj.free_holiday_price = Tool.calcuateMoney(
            this.comboObj.total_free_price / this.comboObj.holiday_day
          );
        }
      }
      this.isCreate = true;
    },
    async postCombo() {
      let comboObj = JSON.stringify(this.comboObj);
      comboObj = JSON.parse(comboObj);
      comboObj.placement = this.placement;

      if (this.placement == 2) {
        comboObj.total_free_price = "";
      }
      if (comboObj.extra_price) {
          comboObj.extra_product = JSON.stringify([{
              classify_type: 'materials',
              value: comboObj.extra_price
          }])
      }
      let ret = await this.$http.improveFreeItem(comboObj);
      if (ret.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.$router.go(-1);
      }
    },
    getComboDay(start, end) {
      let days, time;
      let start_time = new Date(start);
      let end_time = new Date(end);
      time = end_time - start_time;
      days = Math.floor(time / (1000 * 3600 * 24));
      return Math.abs(days) + 1;
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.enjoy-combo {
  .data-form-title {
    font-size: 20px;
    margin-bottom: 30px;
    color: $color_black;
  }
  .self-table {
    .table-name {
      height: 60px;
      background-color: $color_blue;
      opacity: 0.7;
      line-height: 60px;
      color: #fff;
      text-align: center;
      font-size: 14px;
    }
    .table-price {
      height: 60px;
      div {
        line-height: 60px;
        flex: 1;
        text-align: center;
        font-size: 14px;
        border: solid 2px #f9f9fa;
        border-top: none;
      }
    }
    .el-button {
      margin-top: 40px;
    }
  }
  ::v-deep .el-form {
    .el-form-item {
      margin-bottom: 20px;
      color: $color_black;
      .el-form-item__label {
        margin-right: 20px;
        padding-right: 0;
        &:before {
          color: $color_blue;
        }
      }
      i {
        font-style: normal;
        margin: 0 10px;
        &.el-input__icon {
          margin: 0;
        }
      }
      b {
        font-weight: normal;
        color: $color_normal;
      }
    }
    .el-input {
      width: 180px;
    }
  }
}
.combo-notice {
  font-size: 14px;
  padding: 10px;
  border: solid 1px #ebebeb;
  margin-bottom: 20px;
  line-height: 20px;
  display: inline-block;
}
.el-button {
  width: 120px;
  height: 40px;
}
</style>
